/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Export_FormatInputs */

const en_us2_profile_editors_export_format = /** @type {(inputs: Profile_Editors_Export_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In an open format (JSON), to keep or take to another app.`)
};

const pt_br2_profile_editors_export_format = /** @type {(inputs: Profile_Editors_Export_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em formato aberto (JSON), para você guardar ou levar para outro app.`)
};

const es_419_profile_editors_export_format = /** @type {(inputs: Profile_Editors_Export_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En un formato abierto (JSON), para guardarlo o llevarlo a otra app.`)
};

const pt_pt2_profile_editors_export_format = /** @type {(inputs: Profile_Editors_Export_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Num formato aberto (JSON), para guardares ou levares para outra app.`)
};

const fr_fr2_profile_editors_export_format = /** @type {(inputs: Profile_Editors_Export_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dans un format ouvert (JSON), à garder ou à importer dans une autre app.`)
};

const de_de2_profile_editors_export_format = /** @type {(inputs: Profile_Editors_Export_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In einem offenen Format (JSON), zum Aufbewahren oder für eine andere App.`)
};

const it_it2_profile_editors_export_format = /** @type {(inputs: Profile_Editors_Export_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In un formato aperto (JSON), da conservare o portare in un'altra app.`)
};

/**
* | output |
* | --- |
* | "In an open format (JSON), to keep or take to another app." |
*
* @param {Profile_Editors_Export_FormatInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_export_format = /** @type {((inputs?: Profile_Editors_Export_FormatInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Export_FormatInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_export_format(inputs)
	if (locale === "es-419") return es_419_profile_editors_export_format(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_export_format(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_export_format(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_export_format(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_export_format(inputs)
	return en_us2_profile_editors_export_format(inputs)
});
export { profile_editors_export_format as "profile-editors.export_format" }